// src/categories/categoryIdMapping.js
const categoryIdMapping = {
  anexo30Y31Ano2022DatosGenerales: 1,
  anexo30Y31Ano2022SistemasDeMedicion: 2,
  anexo30Y31Ano2022SGM: 3,
  anexo30Y31Ano2022ProgramaInformatico: 4,
  anexo30Y31Ano2022EvidenciasFotograficas: 5,
  anexo30Y31Ano2023DatosGenerales: 6,
  anexo30Y31Ano2023SistemasDeMedicion: 7,
  anexo30Y31Ano2023SGM: 8,
  anexo30Y31Ano2023ProgramaInformatico: 9,
  anexo30Y31Ano2023EvidenciasFotograficas: 10,
  anexo30Y31Ano2024DatosGenerales: 11,
  anexo30Y31Ano2024SistemasDeMedicion: 12,
  anexo30Y31Ano2024SGM: 13,
  anexo30Y31Ano2024ProgramaInformatico: 14,
  anexo30Y31Ano2024EvidenciasFotograficas: 15,
  dictamenDeDisenoDocumentos: 16,
  dictamenDeDisenoPlanos: 17,
  nom016InformacionGeneral: 18,
  nom016Documentacion: 19,
  inspeccion30Y31Ano2024DatosGenerales: 20,
  inspeccion30Y31Ano2024SistemasDeMedicion: 21,
  inspeccion30Y31Ano2024SGM: 22,
  inspeccion30Y31Ano2024ProgramaInformatico: 23,
  inspeccion30Y31Ano2024Politicas: 24,
  anexo30Y31Ano2025DatosGenerales: 25,
  anexo30Y31Ano2025SistemasDeMedicion: 26,
  anexo30Y31Ano2025SGM: 27,
  anexo30Y31Ano2025ProgramaInformatico: 28,
  anexo30Y31Ano2025EvidenciasFotograficas: 29,
  anexo21Y22Rmf2026DatosGenerales: 30,
  anexo21Y22Rmf2026SistemasDeMedicion: 31,
  anexo21Y22Rmf2026SGM: 32,
  anexo21Y22Rmf2026ProgramaInformatico: 33,
  anexo21Y22Rmf2026EvidenciasFotograficas: 34,
  anexo21Y22Rmf2026Certificado: 35,
  transporteAnexo21Y22Rmf2026DatosGenerales2026: 36,
  transporteAnexo21Y22Rmf2026SistemasDeMedicion2026: 37,
  transporteAnexo21Y22Rmf2026SistemasDeMedicion2026DocumentosComplementarios: 38,
  transporteAnexo21Y22Rmf2026SGM2026: 39,
  transporteAnexo21Y22Rmf2026ProgramaInformatico2026: 40,
  transporteAnexo21Y22Rmf2026Certificado2026: 41,
  distribucionAnexo21Y22Rmf2026DatosGenerales2026: 42,
  distribucionAnexo21Y22Rmf2026SistemasDeMedicion2026: 43,
  distribucionAnexo21Y22Rmf2026SGM2026: 44,
  distribucionAnexo21Y22Rmf2026ProgramaInformatico2026: 45,
  distribucionAnexo21Y22Rmf2026Certificado2026: 46,
  comercializadoraAnexo21Y22Rmf2026DatosGenerales2026: 47,
  comercializadoraAnexo21Y22Rmf2026ProgramaInformatico2026: 48,
  comercializadoraAnexo21Y22Rmf2026Certificado2026: 49,
};

export default categoryIdMapping;
